import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import timerSvg from '../../images/timer.svg';
import './Timer.scss';

const getTime = (date) => {
    const start = date.getTime();
    const now = new Date().getTime();
    const elapsed = (now - start) / 1000;
    const ss = elapsed % 60;
    const mm = elapsed / 60;

    return {
        mm: parseInt(mm, 10),
        ss: parseInt(ss, 10)
    };
};

const display2Digits = (number) => {
    let time = '00';
    if (number) {
        const stringNumber = number.toString();
        if (stringNumber.length === 1) {
            time = `0${ number }`;
        } else {
            time = stringNumber;
        }
    }
    return time;
};

class Timer extends Component {
    constructor(props) {
        super(props);
        let start = new Date();
        if (props.timerMsg) {
            start = new Date(props.timerMsg.start);
        }

        this.intervalId = setInterval(this.timer, 1000);
        this.state = getTime(start);
    }

    componentWillReceiveProps(nextProps) {
        const { timerMsg } = nextProps;
        if (timerMsg && timerMsg.start) {
            const { start } = timerMsg;
            this.setState(getTime(start));
        }
    }

    componentWillUnmount() {
        window.clearInterval(this.intervalId);
    }

    render() {
        const { ss, mm } = this.state;
        return (
            <div className='fl-survey-timer'>
                <div className='fl-survey-timer-clock'>
                    <img src={ timerSvg } alt='flow survey' />
                </div>
                <div className='fl-survey-timer-counter'>
                    <span>{ display2Digits(mm) }:{ display2Digits(ss) }</span>
                </div>
            </div>
        );
    }

    timer = () => {
        const { ss, mm } = this.state;
        if (ss === 59) {
            this.setState({
                ss: 0,
                mm: mm + 1
            });
        } else {
            this.setState({ ss: ss + 1 });
        }
    };
}

Timer.propTypes = {
    timerMsg: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
    ])
};

Timer.defaultProps = {
    timerMsg: null
};

const mapStateToProps = (state) => ({
    timerMsg: state.timerReducer
});

export default connect(mapStateToProps, null)(Timer);
